import { mapGetters } from 'vuex';
import _ from 'lodash'

export default {
    computed: {
        ...mapGetters('advancedSearch', [
            'companyId',
            'areaId',
        ]),
    },
    watch: {
        companyId() {
            this.throttledInitAdvancedSearchs();
        },
        areaId() {
            this.throttledInitAdvancedSearchs();
        },
    },
    methods: {
        throttledInitAdvancedSearchs: _.debounce(function () {
            this.initAdvancedSearch();
        }, 100),
        
        // overwrite this in component
        initAdvancedSearch() {
            
        },
    },
}